/**
 * Human-friendly "offline for X" duration used by the Cooktop State badge and
 * the Needs Attention chip. Kept in one place so the badge, chip, and any
 * future surface stay in sync.
 */
export function formatOfflineDuration(ts: number): string {
  const diff = Date.now() - ts;
  if (diff < 60_000) return "just now";
  // Floor so 59.5m stays "59m" instead of rounding up to "60m".
  if (diff < 60 * 60_000) return `${Math.floor(diff / 60_000)}m`;
  if (diff < 24 * 60 * 60_000) return `${Math.floor(diff / (60 * 60_000))}h`;
  return `${Math.floor(diff / (24 * 60 * 60_000))}d`;
}

export function formatOfflineSinceTooltip(ts: number): string {
  return `Offline since ${new Date(ts).toLocaleString()}`;
}
